module.exports = __webpack_public_path__ + "static/the-satanic-verses-bd05fd2dddff340d6130fb9ebe1d6439.jpg";